import React, { useMemo } from 'react'

import { getValidations } from './_helpers/validations'
import { hasValue } from '../../../utils/helpers/value'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const Item = ({ label, condition }) => {
  const hasCondition = hasValue(condition)
  const color = hasCondition ? (condition ? 'green' : 'red') : 'dark3'
  const icon = hasCondition ? (condition ? 'RiCheckboxCircleLine' : 'RiCheckboxBlankCircleLine') : 'RiInformationLine'

  return (
    <>
      <IconText bold color={color} label={label} iconLeft={icon} iconSize={0.9} separatorWeight={0.2} />
      <Separator weight={2} />
    </>
  )
}

const ValidationsInfo = ({ form }) => {
  const validations = useMemo(() => getValidations(), [])

  return (
    <>
      <Separator weight={6} />
      {validations.map((item, index) => (
        <Item key={index} condition={item.check ? item.check(form) : undefined} label={item.label} />
      ))}
      <Separator weight={4} />
    </>
  )
}

export default ValidationsInfo
